import Clarity from "@microsoft/clarity";

import { CLARITY_ID } from "@/env";

// The company record has no plan name, so we describe the plan from its
// billing state: on trial, a legacy (pre-billing) account, or the billing cycle.
const getPlan = (company) => {
  if (company.on_trial) {
    return "trial";
  }
  if (company.is_legacy) {
    return "legacy";
  }
  return company.billing_cycle?.name ?? "unsubscribed";
};

// Tells Clarity who is using this session, with the same user ID we send to
// LogRocket, so a session can be found by user, company, role, plan or country.
// The environment tag tells uat/staging sessions apart, since the lower
// environments share one Clarity project.
// `user` and `company` are the raw (snake_case) API responses.
const identifyClarityUser = ({ user, company }) => {
  // window.clarity only exists once the Clarity script has started. Calling
  // Clarity without it throws, so skip when it is not running.
  if (!CLARITY_ID || !window.clarity || !user || !company) {
    return;
  }

  Clarity.identify(`${user.id}`, undefined, undefined, user.email);
  Clarity.setTag("company_id", `${user.company_uid ?? ""}`);
  Clarity.setTag("role", user.role ?? "");
  Clarity.setTag("plan", getPlan(company));
  Clarity.setTag("country_code", company.country_code ?? "");
  Clarity.setTag("environment", process.env.ENV ?? "");
};

export { identifyClarityUser };
